<template>
	<div>
		<PageHeader
			:data="{
				name: 'Invoices',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
					{ name: client.name, to: '/clients/edit/' + client.id },
					{ name: 'Billings', to: '/clients/edit/' + client.id + '/billing' },
				],
			}"
		/>
		<div class="actions d-flex justify-content-between mb-3"></div>

		<div class="card mb-3">
			<div class="card-body">
				<div class="actions d-flex justify-content-between align-items-center">
					<h5 class="p-0 m-0">Email Notification</h5>
					<button class="btn btn-success btn-sm" @click="sendEmailFlag = !sendEmailFlag">
						Prepare Email
					</button>
				</div>
				<div class="row" v-if="sendEmailFlag">
					<div class="col-md-4">
						<p>
							Name: <strong>{{ client.name }}</strong>
						</p>
						<div class="form-group mb-3">
							<label for="">Email</label>
							<div class="d-flex">
								<input type="text" v-model="email" class="form-control" />
								<button
									title="Update client email address"
									class="btn btn-primary"
									style="min-width:80px"
								>
									Update
								</button>
							</div>
							<small>This will update email address of client</small>
						</div>
						<div class="alert alert-info" role="alert">
							<h4 class="alert-heading">Sending Email Notification</h4>
							<p>
								Email notifications for billing using <b>template</b> from the right side, and
								<b>email address</b> from above.
							</p>
							<hr />
							<p class="mb-0">
								You can copy email template and use it to send email. Or you can just do it from here.
							</p>
						</div>
					</div>
					<div class="col-md-8 data">
						<div class="row mb-3">
							<div class="col-md-3">
								<button class="btn btn-primary btn-sm w-100" @click="applyTemplate(5)">
									5 Days Template <font-awesome-icon :icon="['fab', 'html5']" />
								</button>
							</div>
							<div class="col-md-3">
								<button class="btn btn-primary btn-sm w-100" @click="applyTemplate(10)">
									10 Days Template <font-awesome-icon :icon="['fab', 'html5']" />
								</button>
							</div>
						</div>
						<Editor v-model="emailTemplate" :options="emailTemplateToolbar" />
						<div class="d-flex justify-content-between align-items-center mt-3">
							<button @click="copyToClipboard()" class="btn btn-warning">
								<font-awesome-icon :icon="['fas', 'copy']" /> {{ copyButtonText }}
							</button>
							<button @click="sendEmailNotification()" class="btn btn-primary">
								<font-awesome-icon
									:class="[{ 'fa-spin': loadingSendEmail }]"
									:icon="['fas', loadingSendEmail ? 'spinner' : 'paper-plane']"
								/>
								Send Email
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card mb-3">
			<div class="card-header">
				<div class="actions d-flex justify-content-between align-items-center">
					<h5 class="p-0 m-0">Email Notifications List</h5>
				</div>
			</div>
			<div class="card-body">
				<h6>List of all email notifications</h6>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import { handleErrors } from '../../actions/helpers'
import { Tooltip } from 'bootstrap'
import Editor from '@tinymce/tinymce-vue'
import restApi from '../../api/index.js'
export default {
	name: 'ClientBillingEmailNotifications',
	components: { PageHeader, Editor },
	data() {
		return {
			loading: false,
			loadingSendEmail: false,
			client: {
				name: '',
			},
			emailTemplate: '',
			emailTemplateToolbar: {
				menubar: false,
				plugins: 'link code lists',
				toolbar1:
					'fontselect fontsizeselect formatselect lineheight | bold italic underline strikethrough | bullist numlist | alignleft aligncenter alignright alignjustify | link removeformat code',
			},
			fiveDaysTemplate: ` <p>Hi {{ name }}</p>
								<p>I hope you are doing well! I wasn't sure if you received the email sent a couple days ago from our billing system, so I thought I would follow up with you here with a link to an invoice for .</p>
								<p>Invoice Link: {{ freshbooksLink }}</p>
								<p>Thank you! Cristina Town Web Design 920-645-2823 ext. 703</p>`,
			tenDaysTemplate: `  <p>Hi {{ name }}</p>
								<p>I hope you are doing well! I wasn't sure if you received the email sent a couple days ago from our billing system, so I thought I would follow up with you here with a link to an invoice for .</p>
								<p>Invoice Link: {{ freshbooksLink }}</p>
								<p>Thank you! Cristina Town Web Design 920-645-2823 ext. 703</p>`,
			sendEmailFlag: false,
			email: '',
			copyButtonText: 'Copy',
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	mounted() {},
	created() {
		setTimeout(() => {
			document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
				new Tooltip(el)
			})
		}, 1100)
		this.getClient()
	},
	methods: {
		// Get Client
		getClient() {
			restApi
				.get(`/clients/${this.$route.params.id}`)
				.then(({ data }) => {
					this.client = data
					this.email = data.email
					if (this.$route.query.days) {
						this.sendEmailFlag = true
						if (this.$route.query.days == 5) {
							this.emailTemplate = this.fiveDaysTemplate.replace('{{ name }}', this.client.name)
						}
						if (this.$route.query.days == 10) {
							this.emailTemplate = this.tenDaysTemplate.replace('{{ name }}', this.client.name)
						}
					}
					if (this.$route.query.invoice) {
						this.sendEmailFlag = true
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Fetch Invoices
		fetchInvoices() {
			this.loadingFetch = true
			restApi
				.get(`/freshbooks/invoices/fetch/${this.$route.params.id}`, { params: this.request })
				.then(({ data }) => {
					console.log(data)
					this.loadingFetch = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loadingFetch = false
				})
		},

		// Send Email Notification
		sendEmailNotification() {
			let props = {
				client_id: this.client.id,
				email: this.email,
				template: this.emailTemplate,
			}
			this.loadingSendEmail = true
			restApi
				.post(`/freshbooks/billing/notification/send/email`, props)
				.then(({ data }) => {
					console.log(data)
					this.$swal.fire({
						icon: 'success',
						title: data.message,
						timer: 3000,
					})
					this.loadingSendEmail = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loadingSendEmail = false
				})
		},

		// Applay template
		applyTemplate(days) {
			if (days == 5) {
				this.emailTemplate = this.fiveDaysTemplate.replace('{{ name }}', this.client.name)
			}
			if (days == 10) {
				this.emailTemplate = this.tenDaysTemplate.replace('{{ name }}', this.client.name)
			}
		},

		copyToClipboard() {
			var copyText = this.emailTemplate
			navigator.clipboard.writeText(copyText).then(() => {
				console.log('Copied!')
			})
		},
	},
	filters: {
		removeString: function(value) {
			if (!value) return ''
			value = value.replace('&laquo;', '')
			return value.replace('&raquo;', '')
		},
	},
}
</script>
